import HorizontalScroll from './HorizontalScroll';
export * from './HorizontalScroll';
export default HorizontalScroll;
